<template>
  <div class="privacy">
    <p>
      Ứng dụng này tôn trọng và bảo vệ quyền riêng tư của tất cả người dùng sử
      dụng dịch vụ. Để cung cấp cho bạn các dịch vụ chính xác và được cá nhân
      hóa hơn, ứng dụng này sẽ sử dụng và tiết lộ thông tin cá nhân của bạn theo
      Chính sách bảo mật này. Tuy nhiên, ứng dụng này sẽ xử lý thông tin này với
      mức độ siêng năng và cẩn trọng cao. Trừ khi có quy định khác trong Chính
      sách bảo mật này, ứng dụng này sẽ không tiết lộ hoặc cung cấp thông tin
      này cho bên thứ ba mà không có sự cho phép trước của bạn. Ứng dụng này sẽ
      cập nhật chính sách bảo mật này theo thời gian. Khi đồng ý với Thỏa thuận
      sử dụng dịch vụ ứng dụng này, bạn được coi là đã đồng ý với toàn bộ nội
      dung của Chính sách bảo mật này. Chính sách bảo mật này là một phần không
      thể thiếu của Thỏa thuận dịch vụ ứng dụng này.
    </p>
    <br />

    <div>
      <h4 style="margin: 0">1. Phạm vi áp dụng</h4>
      (a) thông tin đăng ký cá nhân bạn cung cấp theo các yêu cầu của ứng dụng
      này khi bạn đăng ký tài khoản ứng dụng này;
      <br />
      (b) Dữ liệu như ngôn ngữ được sử dụng, ngày và giờ truy cập, thông tin
      tính năng phần cứng và phần mềm và hồ sơ trang web bạn cần;
      <br />
      (c) Dữ liệu cá nhân của người dùng có được từ ứng dụng từ đối tác kinh
      doanh thông qua các phương tiện hợp pháp.
      <br />
      Bạn hiểu và đồng ý rằng các thông tin sau không áp dụng cho Chính sách
      quyền riêng tư này:<br />
      (a) thông tin từ khóa bạn đã nhập khi sử dụng dịch vụ tìm kiếm do ứng dụng
      cung cấp;<br />
      (b) Thông tin liên quan do bạn thu thập trong đơn này, bao gồm nhưng không
      giới hạn ở các hoạt động tham gia, thông tin giao dịch và chi tiết đánh
      giá;
      <br />
      (c) Vi phạm pháp luật hoặc vi phạm Quy tắc ứng xử này và các hành động mà
      ứng dụng này đã thực hiện đối với bạn.
    </div>
    <br />

    <div>
      <h4 style="margin: 0">2. Sử dụng thông tin</h4>
      (a) Ứng dụng này không cung cấp, bán, thuê, chia sẻ hoặc trao đổi thông
      tin cá nhân của bạn cho bất kỳ bên thứ ba nào không liên quan, trừ khi bạn
      đã xin phép trước, hoặc bên thứ ba và ứng dụng (bao gồm cả chi nhánh ứng
      dụng) là riêng biệt hoặc phổ biến. Để cung cấp cho bạn các dịch vụ và sau
      khi dịch vụ kết thúc, nó sẽ bị cấm truy cập tất cả các tài liệu này mà
      trước đây nó có thể truy cập.<br />
      (b) Ứng dụng này cũng không cho phép bất kỳ bên thứ ba nào thu thập, chỉnh
      sửa, bán hoặc phân phối thông tin cá nhân của bạn bằng bất kỳ phương tiện
      nào. Bất kỳ người dùng nào của nền tảng ứng dụng này tham gia vào các hoạt
      động trên, một khi được tìm thấy, ứng dụng có quyền chấm dứt ngay thỏa
      thuận dịch vụ với người dùng.<br />
      (c) Với mục đích phục vụ Người dùng, Ứng dụng có thể sử dụng thông tin bạn
      sử dụng để cung cấp cho bạn thông tin mà bạn quan tâm, bao gồm nhưng không
      giới hạn, gửi cho bạn thông tin sản phẩm và dịch vụ hoặc chia sẻ thông tin
      với Đối tác ứng dụng để họ có thể Gửi cho bạn thông tin về các sản phẩm và
      dịch vụ của nó (sau này cần có sự đồng ý trước của bạn).
    </div>
    <br />

    <div>
      <h4 style="margin: 0">3. Công bố thông tin</h4>
      Trong các trường hợp sau đây, ứng dụng này sẽ tiết lộ toàn bộ hoặc một
      phần thông tin cá nhân của bạn theo mong muốn cá nhân của bạn hoặc của
      pháp luật:<br />
      (a) Tiết lộ cho các bên thứ ba với sự đồng ý trước của bạn;<br />
      (b) Để cung cấp các sản phẩm và dịch vụ bạn yêu cầu, bạn phải chia sẻ
      thông tin cá nhân của mình với các bên thứ ba;<br />
      (c) Tiết lộ cho bên thứ ba hoặc cơ quan hành chính hoặc tư pháp theo các
      quy định có liên quan của pháp luật, hoặc theo yêu cầu của cơ quan hành
      chính hoặc tư pháp;<br />
      (d) Nếu bạn đã vi phạm luật pháp, quy định của Trung Quốc hoặc thỏa thuận
      dịch vụ ứng dụng này hoặc các quy tắc liên quan, bạn cần tiết lộ cho bên
      thứ ba;<br />
      (e) Nếu bạn là Người khiếu nại IP đủ điều kiện và đã nộp đơn khiếu nại,
      thì nên tiết lộ cho Bị đơn theo yêu cầu của Người khiếu nại để cả hai bên
      có thể xử lý các tranh chấp về quyền có thể xảy ra;<br />
      (f) Trong giao dịch được tạo trên nền tảng ứng dụng này, nếu bất kỳ bên
      nào trong giao dịch thực hiện hoặc thực hiện một phần nghĩa vụ giao dịch
      và yêu cầu tiết lộ thông tin, ứng dụng có quyền quyết định cung cấp cho
      người dùng thông tin liên hệ của đối tác, v.v. Thông tin để tạo thuận lợi
      cho việc hoàn thành một giao dịch hoặc giải quyết tranh chấp.<br />
      (g) Các tiết lộ khác mà ứng dụng này cho là phù hợp theo luật pháp, quy
      định hoặc chính sách ứng dụng.
    </div>
    <br />

    <div>
      <h4 style="margin: 0">4. Lưu trữ và trao đổi thông tin</h4>
      Thông tin và tài liệu do bạn thu thập trong ứng dụng này sẽ được lưu trữ
      trên ứng dụng và / hoặc máy chủ của các chi nhánh, có thể được gửi đến
      quốc gia, khu vực hoặc địa điểm nơi ứng dụng thu thập thông tin và tài
      liệu. Nó được truy cập, lưu trữ và hiển thị bên ngoài quốc gia.
    </div>
    <br />

    <div>
      <h4 style="margin: 0">5. Sử dụng cookie</h4>
      (a) Trong trường hợp bạn không từ chối chấp nhận cookie, Ứng dụng sẽ đặt
      hoặc truy cập cookie trên máy tính của bạn để bạn có thể đăng nhập hoặc sử
      dụng các dịch vụ hoặc tính năng dựa trên cookie dựa trên cookie. Ứng dụng
      này sử dụng cookie để cung cấp cho bạn các dịch vụ chu đáo và cá nhân hơn,
      bao gồm các dịch vụ quảng cáo.<br />
      (b) Bạn có quyền chấp nhận hoặc từ chối chấp nhận cookie. Bạn có thể từ
      chối chấp nhận cookie bằng cách sửa đổi cài đặt trình duyệt của bạn. Tuy
      nhiên, nếu bạn chọn từ chối chấp nhận cookie, bạn không thể đăng nhập hoặc
      sử dụng dịch vụ web của ứng dụng này hoặc tính năng dựa trên cookie.<br />
      (c) Chính sách này sẽ áp dụng cho thông tin có được thông qua các cookie
      được cung cấp trong ứng dụng này.
    </div>
    <br />

    <div>
      <h4 style="margin: 0">6. Bảo mật thông tin</h4>
      (a) Tài khoản ứng dụng này có bảo vệ an ninh. Vui lòng giữ thông tin tên
      người dùng và mật khẩu của bạn. Ứng dụng này sẽ đảm bảo thông tin của bạn
      không bị mất, không bị lạm dụng hoặc thay đổi, bằng các biện pháp bảo mật
      như mã hóa mật khẩu người dùng. Mặc dù có các biện pháp bảo mật đã nói ở
      trên, xin lưu ý rằng không có biện pháp bảo mật hoàn hảo nào trên mạng
      thông tin.<br />
      (b) Khi sử dụng dịch vụ web ứng dụng này cho các giao dịch trực tuyến,
      chắc chắn bạn sẽ tiết lộ thông tin cá nhân của mình, như thông tin liên
      lạc hoặc địa chỉ bưu chính, cho đối tác hoặc đối tác tiềm năng. Vui lòng
      bảo vệ thông tin cá nhân của bạn và chỉ cung cấp cho người khác khi cần
      thiết. Nếu bạn thấy rằng thông tin cá nhân của bạn bị rò rỉ, đặc biệt là
      nếu tên người dùng và mật khẩu của ứng dụng bị rò rỉ, vui lòng liên hệ
      ngay với dịch vụ khách hàng của ứng dụng này để ứng dụng có thể thực hiện
      các biện pháp tương ứng.
    </div>
    <br />

    <div>
      <h4 style="margin: 0">7. Thay đổi chính sách bảo mật này</h4>
      . Và trong những trường hợp chúng tôi sẽ tiết lộ thông tin này.<br />
      (b) Công ty có quyền sửa đổi chính sách này bất cứ lúc nào, vì vậy vui
      lòng kiểm tra nó thường xuyên. Trong trường hợp thay đổi quan trọng đối
      với chính sách này, Công ty sẽ thông báo cho bạn bằng cách thông báo về
      đơn đăng ký.
    </div>
    <br />

    <div>
      <h4 style="margin: 0">
        8. Cách để người dùng yêu cầu xóa dữ liệu cá nhân chứa thông tin liên hệ
      </h4>
      A. Đăng nhập vào trang web sau và tự thao tác theo hướng dẫn:
       https://ticket.mgolgames.com/main/deletion <br />
      B. Truy cập Fanpage và liên hệ CSKH để được hỗ trợ<br />
      Xin lưu ý rằng nếu bạn yêu cầu chúng tôi xóa dữ liệu cá nhân của mình,
      chúng tôi có thể giữ lại dữ liệu của bạn khi cần thiết vì lợi ích kinh
      doanh hợp pháp của chúng tôi, chẳng hạn như để tuân thủ các nghĩa vụ pháp
      lý, giải quyết tranh chấp và thực thi các thỏa thuận của chúng tôi. Bạn và
      người giám hộ hợp pháp của bạn nếu bạn là trẻ vị thành niên, có các quyền
      sau đây liên quan đến bất kỳ thông tin cá nhân nào mà chúng tôi có về
      bạn:<br />
      Quyền xem xét hoặc yêu cầu chúng tôi cung cấp cho bạn các bản sao thông
      tin cá nhân mà chúng tôi nắm giữ về bạn bất kỳ lúc nào, với một khoản phí
      theo quy định của pháp luật;<br />
      Quyền yêu cầu chúng tôi cập nhật và chỉnh sửa bất kỳ thông tin cá nhân lỗi
      thời hoặc không chính xác nào mà chúng tôi giữ về bạn miễn phí;<br />
      Quyền yêu cầu chúng tôi ngừng thu thập, xử lý hoặc sử dụng hoặc xóa thông
      tin cá nhân mà chúng tôi nắm giữ về bạn, với điều kiện chúng tôi có thể từ
      chối thực hiện nếu luật pháp yêu cầu.<br />
      Quyền phản đối việc xử lý bất hợp pháp thông tin cá nhân mà chúng tôi có
      về bạn; và Quyền chọn không tham gia bất kỳ thông tin liên lạc tiếp thị
      nào mà chúng tôi (hoặc bất kỳ bên thứ ba nào mà chúng tôi đã tiết lộ thông
      tin cá nhân của bạn với sự đồng ý của bạn) có thể gửi cho bạn.<br />
      Nếu bạn có yêu cầu như vậy, bạn có thể giải quyết yêu cầu của mình tới
      Fanpage<br />
      Nếu bạn từ chối cung cấp thông tin cá nhân của mình hoặc yêu cầu chúng tôi
      xóa hoặc ngừng thu thập thông tin cá nhân của bạn, bạn có thể không sử
      dụng được tất cả hoặc một số phần của Dịch vụ của chúng tôi.<br />
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.privacy {
  text-align: left;
  font-family: auto;
}
</style>
